<form [formGroup]="form" autocomplete="off" class="form-horizontal">
    <div class="mb-3x pr-2">
        <div class="form-check">
            <input
                    type="checkbox"
                    class="form-check-input"
                    id="umsaetzeUeberPlattform"
                    formControlName="umsaetzeUeberPlattform"
                    datevMessagePath="umsaetzeUeberPlattform{{objectId}}"
                    utilsCheckValidity utilsControlState utilsValidationMessage
                    (ngModelChange)="clearPlattformen($event)">
            <label class="form-check-label"
                   for="umsaetzeUeberPlattform">{{ 'COMMON_UI.FRAGEBOGEN.INFLUENCER.UMSAETZE_UEBER_PLATTFORM' | translate }}
            </label>
        </div>
    </div>

    <div *ngIf="data?.umsaetzeUeberPlattform">

        <div *ngIf="data?.plattformen.length > 0" class="form-row">
            <label class="d-none d-sm-inline col-sm-6 col-form-label">
                {{ 'COMMON_UI.FRAGEBOGEN.INFLUENCER.PLATTFORMEN.NAME' | translate }}
            </label>
            <label class="d-none d-sm-inline col-sm-6 col-form-label">
                {{ 'COMMON_UI.FRAGEBOGEN.INFLUENCER.PLATTFORMEN.ACCOUNT_NAME' | translate }}
            </label>
        </div>

        <div *ngFor="let plattform of data?.plattformen; let i=index;">
            <common-ui-plattform (removePlattformClicked)="removePlattform($event)"
                                  [data]="plattform" [index]="i"
                                  [readonly]="readonly"></common-ui-plattform>
        </div>

        <div *ngIf="!readonly && data?.plattformen?.length < 99" class="form-row">
            <div class="col-12 d-flex justify-content-end">
                <button (click)="addPlattform()" class="btn btn-light" id="addPlattform"
                        title="{{ 'COMMON_UI.FRAGEBOGEN.INFLUENCER.ADD_PLATTFORM' | translate }}"
                        type="button">
                    <em class="icon icon-svg icon-fi-hinzufuegen"></em>
                    {{ 'COMMON_UI.FRAGEBOGEN.INFLUENCER.ADD_PLATTFORM' | translate }}
                </button>
            </div>
        </div>
    </div>
</form>
